import { render, staticRenderFns } from "./MayFlashSaleHeroSection.vue?vue&type=template&id=8bf067ec&scoped=true&"
import script from "./MayFlashSaleHeroSection.vue?vue&type=script&lang=js&"
export * from "./MayFlashSaleHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./MayFlashSaleHeroSection.vue?vue&type=style&index=0&id=8bf067ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf067ec",
  null
  
)

export default component.exports